import type { ComponentProps } from "react";
import { StyleSheet, TextInput } from "react-native";

import {
  fonts,
  radii,
  spacing,
  useTheme,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function TextField({
  grow = false,
  muted = false,
  centered = false,
  invalid = false,
  accessibilityLabel,
  placeholder,
  style,
  ...props
}: ComponentProps<typeof TextInput> & {
  grow?: boolean;
  muted?: boolean;
  centered?: boolean;
  invalid?: boolean;
}) {
  const { colors } = useTheme();
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <TextInput
      accessibilityLabel={accessibilityLabel}
      placeholder={placeholder}
      placeholderTextColor={colors.mutedForeground}
      style={[
        stylesheet.input,
        grow ? stylesheet.grow : null,
        muted ? stylesheet.muted : null,
        centered ? stylesheet.centered : null,
        invalid ? stylesheet.invalid : null,
        style,
      ]}
      {...props}
    />
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    input: {
      minHeight: 44,
      paddingHorizontal: spacing.m,
      paddingVertical: spacing.s + 2,
      borderWidth: 1,
      borderColor: colors.borderStrong,
      borderRadius: radii.control,
      backgroundColor: colors.elevated,
      color: colors.foreground,
      fontFamily: fonts.regular,
      fontSize: 15,
    },
    grow: { flex: 1 },
    muted: { opacity: 0.72, backgroundColor: colors.surface },
    centered: { textAlign: "center" },
    invalid: {
      borderColor: colors.danger,
      backgroundColor: colors.dangerSurface,
    },
  });
